import { createAsyncThunk } from "@reduxjs/toolkit"
import { PDFTemplateData } from "@nova/constants"

export const loadPDFDefaultTemplate = createAsyncThunk(
    "pdfs/loadTemplate",
    async ({ workspaceId }: { workspaceId: string }) => {
        if (!workspaceId) return
        const res = await fetch(`/api/organization/${workspaceId}/pdfTemplate`)
        if (!res.ok) return

        const result = await res.json()
        return result?.template as PDFTemplateData | undefined
    }
)
